'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  location: _propTypes2.default.shape({
    href: _propTypes2.default.string,
    assign: _propTypes2.default.func
  }),
  analytics: _propTypes2.default.shape({
    track: _propTypes2.default.func
  })
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/windowPropType.js
// module id = 68
// module chunks = 11